import { jsx } from 'react/jsx-runtime';
import { createContext, useEffect, useContext } from 'react';
import { gql } from 'urql';
import { useQuery } from '../graphql/graphql.js';
import { logError } from '../errors/error-reporting.js';
import '../authentication/AuthenticationContextProvider.js';
import { useIsAuthenticated } from '../authentication/permissions.js';
import { GetGatewayConfigsContext } from '../generated/graphql.js';

const GET_GATEWAY_CONFIGS = gql`
  query GetGatewayConfigs {
    gatewayConfigs {
      returnedSeriesLimit
      returnedDatapointsLimit
      tracingUIEnabled
      collectionsAccess
      serviceUIEnabled
      enableExternalServiceConfig
    }
    tenant {
      tenantConfiguration {
        scrapeInterval
      }
    }
  }
`;
const DEFAULT_GATEWAY_CONFIGS = {
    returnedSeriesLimit: 0,
    returnedDatapointsLimit: 0,
    tracingUIEnabled: false,
    collectionsAccess: 'disabled',
    serviceUIEnabled: false,
    scrapeInterval: '15s',
    enableExternalServiceConfig: false
};
const GatewayConfigsContext = /*#__PURE__*/ createContext(DEFAULT_GATEWAY_CONFIGS);
function GatewayConfigsContextProvider(props) {
    const isAuthenticated = useIsAuthenticated();
    const [{ data, error }] = useQuery({
        query: GET_GATEWAY_CONFIGS,
        context: GetGatewayConfigsContext,
        pause: !isAuthenticated
    });
    // Since we "handle" this error instead of throwing it, make sure it gets reported
    useEffect(()=>{
        if (error === undefined || error === null) return;
        logError(error);
    }, [
        error
    ]);
    let gatewayConfigs = DEFAULT_GATEWAY_CONFIGS;
    if (data && !error) {
        gatewayConfigs = {
            ...data?.gatewayConfigs,
            ...data?.tenant?.tenantConfiguration
        };
    }
    return /*#__PURE__*/ jsx(GatewayConfigsContext.Provider, {
        value: gatewayConfigs,
        children: props.children
    });
}
function useGatewayConfigs() {
    const gatewayConfigs = useContext(GatewayConfigsContext);
    return gatewayConfigs;
}
function areGatewayConfigsLoading(gatewayConfigs) {
    // Gateway configs will return the default values object until data has
    // been loaded from the server, so wait until we have server data
    return gatewayConfigs === DEFAULT_GATEWAY_CONFIGS;
}

export { DEFAULT_GATEWAY_CONFIGS, GatewayConfigsContext, GatewayConfigsContextProvider, areGatewayConfigsLoading, useGatewayConfigs };
//# sourceMappingURL=GatewayConfigs.js.map
